import React from 'react'
import './navheadspacer.css'

const NavheadSpacer = () => {
  return (
    <div id='navhead-spacer'>&nbsp;</div>  )
}

export default NavheadSpacer